import { useEffect, useState } from "react";
import { domainStorage } from "../utils/domainStorage";
import { Domain } from "../models/Domain";

export const useStoredDomain = (): Domain | null => {
  const [domain, setDomain] = useState<Domain | null>(() =>
    domainStorage.get()
  );

  useEffect(() => {
    const handleChange = () => {
      setDomain(domainStorage.get());
    };

    window.addEventListener("domain-storage-changed", handleChange);

    window.addEventListener("storage", handleChange);

    return () => {
      window.removeEventListener("domain-storage-changed", handleChange);
      window.removeEventListener("storage", handleChange);
    };
  }, []);

  return domain;
};
